var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "license"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9991 4C18.8687 4.00011 18.739 4.02573 18.6173 4.07612C18.4346 4.15181 18.2784 4.27998 18.1685 4.44443C18.0586 4.60888 18 4.80222 18 5V6H19C19.1978 6 19.3911 5.94135 19.5556 5.83147C19.72 5.72159 19.8482 5.56541 19.9239 5.38268C19.9996 5.19996 20.0194 4.99889 19.9808 4.80491C19.9422 4.61093 19.847 4.43275 19.7071 4.29289C19.5673 4.15304 19.3891 4.0578 19.1951 4.01922C19.1305 4.00637 19.0643 4 18.9991 4C18.9994 4 18.9988 4 18.9991 4ZM16.1716 4H8C7.46957 4 6.96086 4.21071 6.58579 4.58579C6.21071 4.96086 6 5.46957 6 6V16H13C13.5523 16 14 16.4477 14 17V19C14 19.2652 14.1054 19.5196 14.2929 19.7071C14.4804 19.8946 14.7348 20 15 20C15.2652 20 15.5196 19.8946 15.7071 19.7071C15.8946 19.5196 16 19.2652 16 19V5C16 4.65753 16.0586 4.31949 16.1716 4ZM18 8V19C18 19.7957 17.6839 20.5587 17.1213 21.1213C16.5587 21.6839 15.7957 22 15 22H6C4.93913 22 3.92172 21.5786 3.17157 20.8284C2.42143 20.0783 2 19.0609 2 18V17C2 16.4477 2.44772 16 3 16H4V6C4 4.93914 4.42143 3.92172 5.17157 3.17157C5.92172 2.42143 6.93913 2 8 2H18.9972M4 18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H12.1716C12.0591 19.6818 12 19.3439 12 19V18H4ZM8 7C8 6.44772 8.44772 6 9 6H13C13.5523 6 14 6.44772 14 7C14 7.55228 13.5523 8 13 8H9C8.44772 8 8 7.55228 8 7ZM8 11C8 10.4477 8.44772 10 9 10H13C13.5523 10 14 10.4477 14 11C14 11.5523 13.5523 12 13 12H9C8.44772 12 8 11.5523 8 11Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.f795a629ffe738d5a9c11772e562caac.svg";
export { ForwardRef as ReactComponent };